export default __webpack_public_path__ + "static/modernizzare-business-intelligence-pmi-data-mesh-vs-data-warehouse-1f2380c2a3622ce0a6d3d1a6c2f567a0.jpg";